import axios from 'axios';
import showAlert from './alert';
import history from './history';
import configs from '../config';

axios.defaults.baseURL = configs.apibaseurl;
axios.interceptors.request.use(
  (config) => {
    const auth = { headers: { } };
    auth.headers.Authorization = `Bearer ${localStorage.getItem('access_token')}` || null;
    return { ...config, ...auth };
  },
  (error) => {
    return error;
  }
);
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.config && error.response.config.method !== 'get') {
      switch (error.response.status) {
        case 500:
          showAlert('Something went wrong', 'error');
          break;
        case 402:
          showAlert(error.response.data);
          break;
        case 401:
          localStorage.clear();
          history.push('/unauthorized');
          break;
        case 404:
          showAlert('Something went wrong.', 'error');
          break;
        case 400:
          if (error.response.data.message === null) {
            showAlert('Something went wrong.', 'error');
          }
          break;
        case 422:
          showAlert(error?.response?.data?.Message || 'Something went wrong', 'error');
          break;
        default:
          break;
      }
    }

    return Promise.reject(error);
  }
);

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  patch: axios.patch,
  delete: axios.delete,
  all: axios.all,
  spread: axios.spread
};
